export type FlocklerPost = {
  attachments: PostAttachment[];
  flocklerId: number;
  from: {
    name: string | null;
    username: string | null;
    profileUrl: string | null;
    profileImageUrl: string | null;
  };
  channel:
    | "facebook"
    | "flickr"
    | "flockler"
    | "google_review"
    | "instagram"
    | "link"
    | "linkedin"
    | "pinterest"
    | "review"
    | "rss"
    | "tiktok"
    | "twitter"
    | "vimeo"
    | "youtube";
  ctaLink: {
    url: string;
    title: string | null;
  } | null;
  images: {
    altText: string | null;
    url: string;
  }[];
  pinnedIndex: number | null;
  postType: string;
  publishedAt: string;
  stats?: {
    comments: number;
    reactions?: {
      all?: number;
      likes?: number;
    };
  };
  sourceId: string | null;
  sourceUrl: string;
  tags: string[];
  textRich: string | null;
  textPlain: string | null;
  title: string | null;
  videos: {
    type: "file" | "iframe" | "link";
    url: string;
  }[];
};

export type FacebookReviewAttachment = {
  pageName: string;
  pageUrl: string;
  recommendationType: "positive" | "negative";
  type: "review";
};

export type FlocklerRatingAttachment = {
  rating: number;
  type: "rating";
};

export type InstagramStoryAttachment = {
  type: "storyItem";
  publishedAt: string;
  videoUrl: string;
  imageUrl: string;
};

export type LinkAttachment = {
  type: "link";
  snippet: string;
  title: string;
  url: string;
};

export type PostAttachment = FacebookReviewAttachment | FlocklerRatingAttachment | InstagramStoryAttachment | LinkAttachment;

export type FlockerResponse = {
  meta?: {
    statsApiEndpoint?: string;
  };
  pagination?: {
    newer?: string;
    older?: string;
  };
  posts?: FlocklerPost[];
};

export type FlockerPosts = {
  success: boolean;
  response?: FlockerResponse;
};

async function flockerPosts(siteId: string, apiKey: string, paginatedUrl?: string): Promise<FlockerPosts> {
  const url: string = paginatedUrl ?? `https://api.flockler.app/v2/${siteId}/posts`;
  const response = await fetch(url, { method: "GET", headers: { "X-FL-API-Key": apiKey } });
  if (response.ok) {
    return { success: true, response: await response.json() };
  }
  return { success: false };
}

export default {
  flockerPosts,
};
